module.exports = __webpack_public_path__ + "img/MilkCookies.d6973cfe.svg";